export default "__VITE_ASSET__CEuU1GcR__"